class MockLocalStorage {

    private storage: { [key: string]: string };

    constructor() {
        this.storage = {};
    }

    public getItem(key: string): string | null {
        if (typeof this.storage[key] == 'undefined') return null;
        return this.storage[key];
    }

    public setItem(key: string, value: string): void {
        this.storage[key] = value;
    }

    public removeItem(key: string): void {
        delete this.storage[key];
    }

    public clear(): void {
        this.storage = {};
    }

    public key(index: number): string {
        return (Object.keys(this.storage))[index];
    }
}

export default MockLocalStorage;